<panel>
	<h1>{{ 'system-log.title' | translate }}</h1>
	@if (namespaces && filteredEntityTypes) {
		<section three-columns>
			<div>
				<custom-select [label]="'system-log.filter-namespace' | translate"
							   [selectList]="namespaces"
							   [(value)]="selectedNamespace" />
			</div>
			<div>
				<custom-select [label]="'system-log.filter-entity-type' | translate"
							   [selectList]="filteredEntityTypes"
							   [(value)]="selectedEntityType" />
			</div>
			<div>
				<custom-input [label]="'system-log.filter-entityId' | translate"
							  [(value)]="selectedEntityId" />
			</div>

			<div>
				<date-time-input [label]="'system-log.filter-from' | translate" [(value)]="fromDate" [timeOptional]="false" [timeRange]="[0,24]" [required]="true" />
			</div>
			<div>
				<date-time-input [label]="'system-log.filter-to' | translate" [(value)]="toDate" [timeOptional]="false" [timeRange]="[0,24]" [required]="true" />
			</div>
			<div>
				<custom-select [label]="'system-log.filter-user' | translate"
							   [selectList]="users"
							   [(value)]="selectedUserId" />
			</div>
		</section>
		<section>
			<button #searchButton (click)="updateLogEntries()">{{ 'system-log.filter-search' | translate }}</button>
		</section>
	}
	@else {
		<skeletons [defaultSkeletons]="3" />
	}
	@if (filteredLogEntries) {
		<list-view class="scrollable">
			<header defaultSort="descending">{{ 'system-log.column.timestamp' | translate }}</header>
			<header>{{ 'system-log.column.creator' | translate }}</header>
			<header>{{ 'system-log.column.entity' | translate }}</header>
			<header>{{ 'system-log.column.action' | translate }}</header>
			<row *listData="let entry from filteredLogEntries" (action)="selectedLog = entry" [highlighted]="entry == selectedLog">
				<column [sortValue]="entry.timestamp">{{ getDate(entry.timestamp) | customDate }}</column>
				<column>{{ entry.userId | user:'name' }}</column>
				<column>{{ entry.entityType }}</column>
				<column>{{ entry.entityState }}</column>
			</row>
		</list-view>
		@if (logEntries && filteredLogEntries.length != logEntries.length) {
			<section>{{ 'system-log.showing-x-of-y-entries' | translate: { threshold: filteredLogEntries.length, total: logEntries.length } }}</section>
		}
	}
</panel>
@if (selectedLog != null) {
	<panel>
		<h1>{{ 'system-log.log.title' | translate }}</h1>
		<scrollable>
			<section>
				<text-group>
					<strong class="text-bold-3">Timestamp</strong>
					<div>{{ getDate(selectedLog.timestamp) | customDate:'system' }}</div>
					<strong>User</strong>
					<user [userId]="selectedLog.userId" />
					<strong>EntityType</strong>
					<div>{{ selectedLog.entityType }}</div>
					<strong>EntityId</strong>
					<div>{{ selectedLog.entityId }}</div>
					<strong>Activity scope</strong>
					<div>{{ selectedLog.activityId }}</div>
					<strong>Action</strong>
					<div>{{ selectedLog.entityState }}</div>
				</text-group>
			</section>
			<section>
				<custom-input [inputType]="InputType.Switch" [(value)]="hideUnchanged"> {{ 'system-log.show-only-changes' | translate }}</custom-input>
				<log-changes [previousEntity]="previousValue" [currentEntity]="currentValue" [hideUnchanged]="hideUnchanged" />
			</section>
			@if (relatedScopeLogEntries.length > 1) {
			<h2>{{ 'system-log.related-log-posts' | translate }}</h2>
			<list-view [selectable]="false">
				<header defaultSort="ascending">{{ 'system-log.column.timestamp' | translate }}</header>
				<header>{{ 'system-log.column.entity' | translate }}</header>
				<header>{{ 'system-log.column.action' | translate }}</header>
				<row *listData="let entry from relatedScopeLogEntries" (action)="selectedLog = entry" [highlighted]="entry == selectedLog">
					<column [sortValue]="entry.timestamp">{{ entry.timestamp | customDate:'fullTime' }}</column>
					<column>{{ entry.entityType }}</column>
					<column>{{ entry.entityState }}</column>
				</row>
			</list-view>
			}
		</scrollable>
	</panel>
}
